import logUtil from 'utils/log'
import updateCurrentSidebarAction from 'modules/sidebar/redux/actions/update-current'
import { SIDEBAR_ID } from 'modules/sidebar/constants'
import getItemsCountCartSelect from 'modules/cart/redux/selectors/get-items-count'
import logEventConversionUtil from 'modules/conversion/utils/log-event'
import { CONVERSION_EVENT } from 'modules/conversion/constants'
import isGiftUrlLocationUtil from 'utils/location/is-gift-url'

export default function openMiniCartSidebarGiftAction (props) {
  return (dispatch, getState) => {
    logUtil('openMiniCartSidebarGiftAction').debug('[start] props=', props)
    const itemsCount = getItemsCountCartSelect(getState())
    logEventConversionUtil(CONVERSION_EVENT.VIEW_CART)
    const title = `${isGiftUrlLocationUtil() ? 'Gift set' : 'Your cart'} (${itemsCount})`
    dispatch(updateCurrentSidebarAction(SIDEBAR_ID.MINI_CART, { title }))
  }
}
